export const CLINIC = {
  name: "Calm Dentistry",
  tagline: "Relax. Restore. Smile.",
  doctor: "Dr Raksha Shetty",
  phones: ["+91 98708 08543", "+91 80972 74081"],
  phoneDial: ["+919870808543", "+918097274081"],
  email: "drrakshashetty@calmdentistry.in",
  address:
    "Shop no. 15, Tristar CHS Ltd, Srishti Complex, 7, Saki Vihar Rd, opp. L&T Gate, Saki Vihar, Marol, Powai, Mumbai — 400072",
  mapsUrl: "https://maps.app.goo.gl/txdkwxLRLnnNyoFGA",
  whatsapp:
    "https://api.whatsapp.com/send/?phone=918097274081&text=Hi&type=phone_number&app_absent=0",
  hours: "Mon – Sat · 10:00 – 20:00",
};

export const SERVICES = [
  { n: "01", title: "Checkups & Digital X-rays", desc: "Preventive exams that catch issues early with low-radiation imaging." },
  { n: "02", title: "Cleaning & Polishing", desc: "Gentle removal of plaque, tartar and surface stains — a fresher smile in under an hour." },
  { n: "03", title: "Root Canals",  desc: "Modern, painless single-visit endodontics that save your natural tooth." },
  { n: "04", title: "Laser Gum Therapy", desc: "Diode-laser treatments for gums with minimal discomfort and faster healing." },
  { n: "05", title: "Crowns & Bridges", desc: "Custom-crafted ceramic restorations for strength, stability and a natural look." },
  { n: "06", title: "Cosmetic Dentistry", desc: "Veneers, contouring and smile design tailored to your face and personality." },
  { n: "07", title: "Teeth Whitening", desc: "Professional in-chair and take-home whitening — safe, gentle, effective." },
  { n: "08", title: "Braces & Clear Aligners", desc: "Invisalign-style aligners and modern braces for adults and teens." },
  { n: "09", title: "Dental Implants", desc: "Titanium implants that feel and function like your own teeth." },
  { n: "10", title: "Full-Mouth Reconstruction", desc: "Complex, life-changing rehabilitation planned and executed with care." },
  { n: "11", title: "Paediatric Dentistry", desc: "Friendly, calming care for growing smiles — no fear, no fuss." },
  { n: "12", title: "Extractions & Oral Surgery", desc: "Routine and surgical extractions with precise, comfortable techniques." },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Calm is the treatment",
    body:
      "We designed a clinic that feels less like a chair and more like a room you'd want to stay in. Warm earthy tones, natural textures, and soft light — because your nervous system deserves care too.",
  },
  {
    n: "02",
    title: "Gentle, precise, personal",
    body:
      "Every mouth is a small landscape with its own history. Dr Raksha Shetty listens first, plans second, and treats with the kind of patience that turns dental fear into curiosity.",
  },
  {
    n: "03",
    title: "Modern, quietly",
    body:
      "Digital scanning, laser therapy, single-visit root canals — the technology is state-of-the-art. But you'll notice the calm before you notice the equipment.",
  },
  {
    n: "04",
    title: "For Andheri East, Powai and everyone in between",
    body:
      "We're rooted in Marol / Saki Vihar and proud to serve Mumbai's east — a neighbourhood dentist with metropolitan standards, right across from L&T Gate.",
  },
];

export const PILLARS = [
  { title: "Soothing experience", body: "Calming ambience, tranquil colours and gentle care that lower dental anxiety on first visit." },
  { title: "Comprehensive care",  body: "From preventive to cosmetic and full-mouth rehab — one place, one team, one plan." },
  { title: "Personalised attention", body: "Small caseload, unhurried appointments and treatment plans built around you." },
  { title: "Modern & hygienic",   body: "Advanced tech with strict sterilisation and patient-safety protocols throughout." },
];

export const TESTIMONIALS = [
  { name: "Kunal", city: "Andheri East", body: "Dr Raksha guided me through my aligner treatment patiently and professionally. The results are fantastic and the entire process was managed beautifully." },
  { name: "Shobha", city: "Powai",       body: "Dr Raksha made my first dental visit extremely comfortable. She is calm, patient and explains everything clearly. I felt genuinely cared for." },
  { name: "Manali", city: "Chandivali",  body: "I was very anxious about a root canal, but she made the entire process painless and stress-free. Her gentle approach makes a huge difference." },
  { name: "Rahul",  city: "Marol",       body: "The clinic itself is a calming experience. My kids actually look forward to their check-ups now — that's a first." },
  { name: "Priya",  city: "Sakinaka",    body: "Ceramic veneers done with real artistry. Natural, subtle, and exactly what I wanted. Would recommend to anyone in Mumbai." },
];

export const FAQS = [
  { q: "Where is Calm Dentistry located?", a: "We're in Tristar CHS, Srishti Complex, Saki Vihar Road — opposite L&T Gate — serving Andheri East, Powai, Marol and Sakinaka." },
  { q: "Do you take walk-ins?",           a: "We do, but pre-booked appointments get priority and shorter wait times. WhatsApp or call us to reserve a slot." },
  { q: "Are your root canals really painless?", a: "Modern anaesthesia, single-sitting protocols and a gentle-first philosophy keep discomfort minimal for the vast majority of patients." },
  { q: "Do you treat children?",          a: "Yes — paediatric dentistry is one of our focus areas. The calming environment helps kids feel safe from the first visit." },
  { q: "Which insurance and payment methods do you accept?", a: "We accept UPI, cards and cash. For insurance reimbursements we provide detailed invoices and dental notes on request." },
];
